module.exports = __webpack_public_path__ + "img/2-3.993d174.svg";